import { HTTP_METHODS } from "@src/constants/http-methods.constant";
import { INTERNAL_API_ENDPOINTS } from "@src/constants/internal-api-endpoints-constants";
import type { ApiCallConfig } from "@src/utils/api-client";

export interface ProviderAvailabilityBatchRequestProvider {
  providerId: string;
  clinicianType?: string;
  departmentIds?: number[];
}

export interface ProviderAvailabilityBatchParams {
  user_uuid?: string;
  context_id?: number;
  modality?: string;
  user_timezone?: string;
  ageRange?: string | null;
  dateOffset?: number;
  providers: ProviderAvailabilityBatchRequestProvider[];
  monitoring?: {
    exposureSource:
      | "patient_navigator_override"
      | "api_assignment"
      | "percentage_cohort"
      | "not_exposed";
    configuredPercent: number;
    rolloutBucket: number | null;
    clientCorrelationId: string;
    featureVariant?: string;
  };
}

/** Builds the callApi config for the provider-availability-batch endpoint. */
export function buildProviderAvailabilityBatchConfig(
  params: ProviderAvailabilityBatchParams,
  signal?: AbortSignal,
): ApiCallConfig {
  return {
    method: HTTP_METHODS.POST,
    endpoint: INTERNAL_API_ENDPOINTS.PROVIDER_AVAILABILITY_BATCH,
    body: {
      user_uuid: params.user_uuid,
      context_id: params.context_id,
      modality: params.modality,
      user_timezone: params.user_timezone,
      ageRange: params.ageRange,
      dateOffset: params.dateOffset,
      providers: params.providers,
      monitoring: params.monitoring,
    },
    ...(signal ? { signal } : {}),
  };
}
